import { type FC } from 'react';
import { Stack } from '@mantine/core';
import { useUnit } from 'effector-react';
import { Filters, $filters, OrdersList } from './components';
import { paginationModel } from './model';

export const History: FC = () => {
    const { filters } = useUnit({
        filters: $filters,
    });

    return (
        <Stack gap='sm'>
            <Filters onReset={paginationModel.reset} />

            <OrdersList
                filters={filters}
                paginationModel={paginationModel}
            />
        </Stack>
    );
};
